import type React from "react"
import { useTranslation } from "react-i18next"

import EmptyChart from "@/modules/site/components/site/emptyChart"

import { INTERVAL_CHART_MAX_DATA_POINTS } from "./interval-data-selection"
import type { IntervalDataEmptyVariant } from "./resolve-interval-chart-view"

interface IntervalDataEmptyCopy {
  description: string
  title: string
}

interface IntervalDataEmptyProps {
  variant: IntervalDataEmptyVariant
}

const EMPTY_COPY_KEY: Record<IntervalDataEmptyVariant, IntervalDataEmptyCopy> =
  {
    load_error: {
      description: "intervalData.empty.loadError.description",
      title: "intervalData.empty.loadError.title",
    },
    no_capability: {
      description: "intervalData.empty.noData.description",
      title: "intervalData.empty.noData.title",
    },
    no_points: {
      description: "intervalData.empty.noPoints.description",
      title: "intervalData.empty.noPoints.title",
    },
    too_many_points: {
      description: "intervalData.empty.tooManyPoints.description",
      title: "intervalData.empty.tooManyPoints.title",
    },
  }

export const IntervalDataEmpty: React.FC<IntervalDataEmptyProps> = ({
  variant,
}) => {
  const { t } = useTranslation("sites")
  const copy = EMPTY_COPY_KEY[variant]

  return (
    <EmptyChart
      header={t(copy.title, { max: INTERVAL_CHART_MAX_DATA_POINTS })}
      subHeader={t(copy.description)}
    />
  )
}
